import { SigManage } from "@/utils/sig-manage"
import { OneLinePower } from "@/globel/oneLinePower.js"
import { SafetyPanel } from "@/globel/safetyPanel.js"
export class Globel {
  constructor() {
    this.oneLinePower = new OneLinePower()
    this.safetyPanel = new SafetyPanel()
    this.pipeData = []
    this.pipeItems = {}
    this.synchronizationValve = 0
    this.activeKnobs = []

    // 合闸数量--数组
    this.generatorClosedNumber = []

    // 当前选中的系统id
    this.systemId = ""

    // 空压机tab
    this.devicesList = []

    // 集控台tab
    this.controlPanelList = []

    // 气动系统tab
    this.pneumaticSystemList = []

    // 记录调速开关状态,双旋钮要判断两个开关的状态
    this.speedSwitchState1 = [
      {
        id: 1,
        state: false,
        nodeId: "knob_K07_1",
        targetId: "mainGenerator1",
        mode: "LOWER",
      },
      {
        id: 2,
        state: false,
        nodeId: "knob_K07_1",
        targetId: "mainGenerator1",
        mode: "RAISE",
      },
    ]

    this.speedSwitchState2 = [
      {
        id: 3,
        state: false,
        nodeId: "knob_K07_2",
        targetId: "mainGenerator2",
        mode: "LOWER",
      },
      {
        id: 4,
        state: false,
        nodeId: "knob_K07_2",
        targetId: "mainGenerator2",
        mode: "RAISE",
      },
    ]

    this.speedSwitchState3 = [
      {
        id: 5,
        state: false,
        nodeId: "knob_K07_3",
        targetId: "mainGenerator3",
        mode: "LOWER",
      },
      {
        id: 6,
        state: false,
        nodeId: "knob_K07_3",
        targetId: "mainGenerator3",
        mode: "RAISE",
      },
    ]
    // 主进程消息处理接口
    this.sigManage = new SigManage(this)

    // 当前备车状态
    this.standby = ""

    // 当前备车响应状态
    this.standbyRead = ""

    this.standbyAudio = new Audio("alarm.wav")

    this.ruleAudio = new Audio("alarm.wav")

    this.falutAudio = new Audio("alarm.wav")

    this.standbyAudio.loop = true

    this.ruleAudio.loop = true

    this.falutAudio.loop = true

    // 四个气阀状态
    this.airCylinder1 = false
    this.airCylinder2 = false
    this.airCylinder3 = false
    this.airCylinder4 = false

    // 主机转速
    this.hostSpeed = 0

    // 集控台上锁
    this.controlPanelLock = false

    // 驾驶台上锁
    this.drivingPanelLock = false

    // 按钮对应字符串映射
    this.buttonMap = {
      button_M07_1: {
        label: "bridge",
        state: false,
        timer: null,
      },
      button_M07_2: {
        label: "ecr",
        state: false,
        timer: null,
      },
      button_M07_3: {
        label: "local",
        state: false,
        timer: null,
      },
      button_N01_1: {
        label: "bridge",
        state: false,
        timer: null,
      },
      button_N01_2: {
        label: "ecr",
        state: false,
        timer: null,
      },
      button_N01_3: {
        label: "local",
        state: false,
        timer: null,
      },
    }

    this.buttonMap2 = {
      button_M07_4: {
        label: "atsea",
        state: false,
        timer: null,
      },
      button_M07_5: {
        label: "standby",
        state: false,
        timer: null,
      },
      button_M07_6: {
        label: "fwe",
        state: false,
        timer: null,
      },
      button_N01_4: {
        label: "atsea",
        state: false,
        timer: null,
      },
      button_N01_5: {
        label: "standby",
        state: false,
        timer: null,
      },
      button_N01_6: {
        label: "fwe",
        state: false,
        timer: null,
      },
    }

    // 舵机泵状态
    this.rudderPumbState = false

    // 舵令
    this.angle = 0

    // 实际舵角
    this.angleReal = 0

    // 1号舵机锁闭阀是否开启
    this.beLock1 = false

    // 2号舵机锁闭阀是否开启
    this.beLock2 = false

    // 1号舵机隔离阀是否开启
    this.seal1 = false

    // 2号舵机隔离阀是否开启
    this.seal2 = false

    // 点火状态
    this.fireState = ""

    // 组合锅炉操作程序状态
    this.boilerStatus = ""

    // 故障列表
    this.faultList = []

    // 故障key列表
    this.faultKeyList = ["LOW_SPEED_FAILURE", "MGLOF", "ACOF"]

    // 应急电网状态
    this.emergencyPowerGridState = ""

    // 主电网状态
    this.mainPowerGridState = ""

    // 主机是否是自动控制模式
    this.isAutoControl = false

    // 当前驾驶台车钟值
    this.currentDrivingCarClock = "Stop"

    // 当前集控台车钟值
    this.currentControlCarClock = "Stop"

    // 报警的界面
    this.alarmLedBlink = {
      Sys_M07: {
        state: false,
      },
      Sys_N01: {
        state: false,
      },
    }

    // 当前报警的系统
    this.currentAlarmSys = ""

    // 另一个界面需要高亮的档位
    this.currenthighlightGear = ""

    // 驾控界面start blocked文字
    this.drivingPanelBlocked = "Start Blocked"

    // 主机运行时间
    this.hostRunTime = ""

    // 主机rev
    this.hostRev = ""

    // 主机m/e onLoad
    this.hostload = 0

    // 主机setp
    this.hostSetp = 0

    // 主机lever
    this.hostLever = 0

    // 主机启动空气
    this.hostStartAir = 0

    // 集控面板应急停止开盖
    this.controlPanelEmergencyStop = false

    // 驾控
    this.drivingPanelEmergencyStop = false

    // 全局定时器id
    this.globalTimer = null

    // 闪烁标识
    this.light = false

    // 锅炉电源
    this.boilerPower = false

    this.systemName = "模拟图目录总览"

    // 保存点击进入系统的id数组
    this.systemPage = []

    // 当前切换的系统下标
    this.currentIndex = 0

    this.systemPageIndex = 0

    this.time = ""

    this.rudderRotation = 0

    // 三台发电机得气缸废气温度,冷却水出口温度
    this.tankWasteTemperature1 = 36
    this.tankWasteTemperature2 = 36
    this.tankWasteTemperature3 = 36

    this.cylinderCoolingTemperature1 = 36
    this.cylinderCoolingTemperature2 = 36
    this.cylinderCoolingTemperature3 = 36

    this.knobTouchList = []

    this.doubleClick = false

    // 主机数据
    this.hostData = {
      // 四个气动系统阀
      airCylinder1: false,
      airCylinder2: false,
      airCylinder3: false,
      airCylinder4: false,
      load: 0,
      // 启动空气压力
      airStartPressure: 0,
      standby: "",
      standbyRead: "",
      // 当前所在权限
      system: "",
      // 发出的权限
      rule: "",
      BGMachineTelegraph: "",
      ECRMachineTelegraph: "",
      // 本地控制车钟
      mainGear: "0",
      // 转速
      hostSpeed: 0,
      hostRunTime: "",
      hostRev: "",
      // 气缸温度
      cylinderTemperature: 36,
      // 进入空冷器前温度
      beforeAirCoolerTemperature: 36,
      // 空冷器后温度
      afterAirCoolerTemperature: 36,
      // 进入鼓风机前温度
      beforeBlowerTemperature: 36,
      // 增压器后的排气温度
      afterTurbochargerTemperature: 36,
      // 增压器前的排气温度
      beforeTurbochargerTemperature: 36,
      // 主机1号增压器转速
      turbochargerSpeed1: 0,
      // 起动空气压力
      startAirPressure: 0,
      // 缸套冷却水出口温度
      // cylinderCoolingTemperature: 85,
      // 缸套冷却水入口温度
      // cylinderCoolingTemperatureRu: 83,
      // 缸套冷却水入口压力
      // cylinderCoolingPressure: 3.6,
      // 主机功率
      hostPower: 0,
      // 主机燃油消耗率
      hostFuelConsumption: 0,
      // 高温淡水进机温度
      inHighWaterTemperature: 0,
      // 滑油压力
      oilPressure: 0,
      // 滑油温度
      oilTemperature: 0,
      // 主机燃油进机温度与粘度
      temperatureViscosity: 0,
      // 主机燃油进机压力
      pressure: 0,
      // 主机燃油滤器前后压差
      differentialPressure: 0,
      // 主机燃油排烟温度
      gasTemperature: 0,
      // 滑油进机压力
      inPressure: 0,
      // 滑油进机温度
      inTemperature: 0,
      // 滑油进出压差
      pressureDifference: 0,
      // 滑油出口温度
      outTemperature: 0,
      // 中央冷却水/海水淡水进压力
      inFreshwaterPressure: 0,
      // 中央冷却水/海水淡水出压力
      outFreshwaterPressure: 0,
      // 中央冷却水/海水淡水进温度
      inFreshwaterTemperature: 0,
      // 中央冷却水/海水淡水出温度
      outFreshwaterTemperature: 0,
      // 中央冷却水/海水海水进入压力
      inSeawaterPressure: 0,
      // 中央冷却水/海水海水出压力
      outSeawaterPressure: 0,
      // 中央冷却水/海水海水进温度
      inSeawaterTemperature: 0,
      // 中央冷却水/海水海水出温度
      outSeawaterTemperature: 0,
      // 增压器系统扫气压力
      superchargerScavengingPressure: 0,
      // 增压器系统扫气进入温度
      inSuperchargerScavengingTemperature: 0,
      // 增压器系统扫气出温度
      outSuperchargerScavengingTemperature: 0,
      // 增压器系统轴承滑油温度
      bearingOilTemperature: 0,
      // 增压器系统轴承滑油压力
      bearingOilPressure: 0,
      // 冷却水进温度
      inWaterTemperature: 0,
      // 冷却水进压力
      inWaterPressure: 0,
      // 冷却水出温度
      outWaterTemperature: 0,
      // 主机功率
      power: 0,
      // 主机燃油消耗率
      fuelConsumption: 0,
    }

    // 需要发送的打他数据
    this.frequencyData = {}

    // 命令
    this.currentCommand = ""

    // 隔离阀
    this.seal1 = true
    this.seal2 = true

    this.startGloalTimer()

    //蓄能器
    this.electricStorage = 0

    //水位值
    this.waterSupply = 0

    //水位上限值+
    this.waterSupplyMax = 150

    //水位下限值+
    this.waterSupplyMin = 100

    //蒸汽值
    this.steamPressure = 0

    //蒸汽上限值+
    this.steamPressureMax = 0.54

    //蒸汽下限值+
    this.steamPressureMin = 0.46

    /* 报警故障分组全部列表 */
    this.alarmList = []

    /* 报警故障列表 历史记录 */
    this.alarmHistoryList = []

    /* 当前触发报警故障的列表 */
    this.alarmCurrentList = []

    /* 侧边栏缩放 故障数量 展开 */
    this.sidebarCollapse = false

    /* 双击查看故障信息 */
    this.dragBool = false

    /* 报警首页 */
    this.alarmHome = "home"

    /* 侧边栏报警触发对应的数量 */
    this.alarmCount = [
      {
        name: "All Data",
        count: 0,
      },
      {
        name: "M/E GENERAL",
        count: 0,
      },
      {
        name: "M/E COOL FW SYS",
        count: 0,
      },
      {
        name: "M/E PISTON COOL",
        count: 0,
      },
      {
        name: "M/E COOL SW SYSTE",
        count: 0,
      },
      {
        name: "M/E LO SYSTEM",
        count: 0,
      },
      {
        name: "M/E FO SYSTEM",
        count: 0,
      },
      {
        name: "M/E EXH GAS SYSTEM",
        count: 0,
      },
      {
        name: "M/E AIR SYSTEM",
        count: 0,
      },
      {
        name: "AUX BOILER",
        count: 0,
      },
      {
        name: "FIRE SYSTEM",
        count: 0,
      },
      {
        name: "POWER STATION",
        count: 0,
      },
      {
        name: "NO.1 D/G",
        count: 0,
      },
      {
        name: "NO.2 D/G",
        count: 0,
      },
      {
        name: "NO.3 D/G",
        count: 0,
      },
      {
        name: "IGS, COP & WBP SYS",
        count: 0,
      },
      {
        name: "MISCELLANEOUS",
        count: 0,
      },
      {
        name: "TANK LEVEL",
        count: 0,
      },
      {
        name: "AUX MACHINERY",
        count: 0,
      },
      {
        name: "RUNNING HOUR",
        count: 0,
      },
    ]

    //绝缘测试按钮
    this.textbuttonstate = "OFF"

    //接地灯数组
    // this.groundingLeds = []

    /* 双击获取的数据 */
    this.alarmInfo = {}

    /* 历史故障列表 'history' 、 当前故障列表 'alarm' 、全部故障数据列表 'summary' 共用双击组件  标记位 */
    this.alarmMark = "alarm"

    /* 侧边栏点击筛选当前故障key 标记位 */
    this.alarmListMark = ""

    /* 侧边栏点击弹窗 标记为 Bool */
    this.alarmDialog = false

    /* 模拟转速 */
    this.simulationSpeedData = {
      speed: 0,
      state: false,
    }

    /* 固定转速极限值 */
    this.fixedSpeedData = {
      speed: 0,
      state: false,
    }
    /* 当前点击是模拟转速还是固定转速 */
    this.currentClick = ""

    // 应急配电板状态
    this.emergencyPowerSupply = false

    // 主配电板状态
    this.mainPowerSupply = false

    //主发电机转速
    this.rpm1 = 0
    this.rpm2 = 0
    this.rpm3 = 0

    //主发电机增压空气
    this.pressurizedAir1 = 0
    this.pressurizedAir2 = 0
    this.pressurizedAir3 = 0

    //主发电机高温淡水
    this.hyperthermiaWater1 = 0
    this.hyperthermiaWater2 = 0
    this.hyperthermiaWater3 = 0

    //主发电机低温淡水
    this.hypothermiaWater1 = 0
    this.hypothermiaWater2 = 0
    this.hypothermiaWater3 = 0

    //主发电机滑油压力
    this.grease1 = 0
    this.grease2 = 0
    this.grease3 = 0

    //主发电机燃油压力
    this.fuelOil1 = 0
    this.fuelOil2 = 0
    this.fuelOil3 = 0

    //主发电机高温淡水温度
    this.hyperthermiaWaterTemperature1 = 0
    this.hyperthermiaWaterTemperature2 = 0
    this.hyperthermiaWaterTemperature3 = 0

    //主发电机启动空气
    this.startAir1 = 0
    this.startAir2 = 0
    this.startAir3 = 0

    //主发电机控制空气
    this.controlAir1 = 0
    this.controlAir2 = 0
    this.controlAir3 = 0

    // 本地车钟旋钮档位
    this.localNotch = "0"

    // G06Tab
    this.g06DeviceList = []
    this.g06coldList = []

    //备份ID列表
    this.savedRedisIds = []
  }

  getComputedStyle(item) {
    return {
      position: "absolute",
      left: item.position?.x + "px",
      top: item.position?.y + "px",
      width: item.position?.width + "px",
      height: item.position?.height + "px",
    }
  }

  // 单指发送频率
  sendFrequency(currentCommand, data) {
    window.$http
      .post(currentCommand, data)
      .then(() => {})
      .catch((error) => {
        console.log("error: ", error)
      })
  }

  // 双指发送频率或功率
  sendTwoPower(data) {
    window.$http
      .post("SyncScreenAndCommunication/switch/FrequencyAdjustment", data)
      .then(() => {})
      .catch((error) => {
        console.log("error: ", error)
      })
  }

  startGloalTimer() {
    this.globalTimer = setInterval(() => {
      this.light = !this.light
      // 获取时间
      let date = new Date()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      if (second < 10) {
        second = "0" + second
      }
      this.time = `${hour}:${minute}:${second}`

      // 发送频率
      if (this.knobTouchList.length === 1) {
        this.sendFrequency(this.currentCommand, this.frequencyData)
      } else if (this.knobTouchList.length === 2) {
        this.sendTwoPower(this.frequencyData)
      }
    }, 1000)
  }

  clearIntervalChange() {
    Object.keys(this.buttonMap).forEach((key) => {
      if (this.buttonMap[key].timer) {
        clearInterval(this.buttonMap[key].timer)
        this.buttonMap[key].timer = null
      }
    })
  }

  clearIntervalChangeStandby() {
    Object.keys(this.buttonMap2).forEach((key) => {
      if (this.buttonMap2[key].timer) {
        clearInterval(this.buttonMap2[key].timer)
        this.buttonMap2[key].timer = null
      }
    })
  }

  resetButtonMap() {
    this.clearIntervalChange()

    for (let key in this.buttonMap) {
      this.buttonMap[key].state = false
    }
  }

  resetButtonMapStandby() {
    this.clearIntervalChangeStandby()

    for (let key in this.buttonMap2) {
      this.buttonMap2[key].state = false
    }
  }

  setAlarmandLed(state) {
    let value = 0
    if (state) {
      value = 1
    }

    // 黄色的报警灯
    let json1 = {
      type: 2,
      address: 1234,
      id: 3,
      value: value,
    }

    // 声音喇叭
    let json2 = {
      type: 2,
      address: 1234,
      id: 4,
      value: value,
    }

    this.sigManage.setAlarmState(json1)

    setTimeout(() => {
      this.sigManage.setAlarmState(json2)
    }, 500)
  }

  // 消音
  setAlarmMute(state) {
    let value = 0
    if (state) {
      value = 1
    }


    // 声音喇叭
    let json = {
      type: 2,
      address: 1234,
      id: 4,
      value: value,
    }

    this.sigManage.setAlarmState(json)
  }
}
